define("shared/components/shared/social/tiktok-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/computed", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _computed, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <div class="u--row u--row--noCollapse u--m__lr__0">
        {{! Left Column }}
        <div class="u--col__4 u--p__r__0">
          <img alt class="o--media u--p__tb__lg u--p__l__md" src="assets/images/img--setup__titok.png" />
        </div>
        {{! Right Column }}
        <div class="u--col__8">
          <modal.card-header @title={{t "tiktok.add_profile.title"}} class="u--p__l" />
          <div class="u--p__l u--p__r__md u--m__b__lg">
            {{! Username Input }}
            <p class="u--text--bold">{{t "tiktok.add_profile.add_username"}}</p>
            <div class="o--formWrapper">
              <Input
                @type="text"
                @value={{this.tiktokHandle}}
                class="o--form__input"
                placeholder={{t "tiktok.add_profile.add_username_placeholder"}}
              />
              <span class="o--form__helpText">
                {{t "tiktok.add_profile.forgot_username"}}
              </span>
            </div>
            <p>
              {{t "tiktok.add_profile.info"}}
              <span {{on "click" (toggle-action "showTiktokDetailsModal" this)}}>
                {{svg-jar "info" class="o--icon u--cursor"}}
              </span>
            </p>
            {{! Divider }}
            <hr class="u--m__tb__lg" />
            {{! Checkboxes }}
            <div class="o--form__checkbox u--m__b">
              <label class="o--checkbox__label">
                <Input @checked={{this.notificationPostTerms}} @type="checkbox" />
                {{t "tiktok.add_profile.notification_terms"}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <modal.card-footer>
        <Shared::Ui::Button @onClick={{@handleClose}} @text={{t "shared_words.cancel"}} @variant="outline" />
        <Shared::Ui::Button
          @isDisabled={{not this.isAddProfileEnabled}}
          @onClick={{this.addTiktokProfile}}
          @text={{t "tiktok.add_profile.add_handle_btn"}}
          @variant="primary"
          class="u--float--right"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  {{#if this.showTiktokDetailsModal}}
    <Shared::Social::TiktokDetails @handleClose={{set this "showTiktokDetailsModal" false}} />
  {{/if}}
  */
  {
    "id": "5HPj/hdR",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"u--row u--row--noCollapse u--m__lr__0\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"u--col__4 u--p__r__0\"],[12],[1,\"\\n        \"],[10,\"img\"],[14,\"alt\",\"\"],[14,0,\"o--media u--p__tb__lg u--p__l__md\"],[14,\"src\",\"assets/images/img--setup__titok.png\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n        \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__l\"]],[[\"@title\"],[[28,[37,1],[\"tiktok.add_profile.title\"],null]]],null],[1,\"\\n        \"],[10,0],[14,0,\"u--p__l u--p__r__md u--m__b__lg\"],[12],[1,\"\\n\"],[1,\"          \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,1],[\"tiktok.add_profile.add_username\"],null]],[13],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n            \"],[8,[39,2],[[24,0,\"o--form__input\"],[16,\"placeholder\",[28,[37,1],[\"tiktok.add_profile.add_username_placeholder\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"tiktokHandle\"]]]],null],[1,\"\\n            \"],[10,1],[14,0,\"o--form__helpText\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"tiktok.add_profile.forgot_username\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"tiktok.add_profile.info\"],null]],[1,\"\\n            \"],[11,1],[4,[38,3],[\"click\",[28,[37,4],[\"showTiktokDetailsModal\",[30,0]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon u--cursor\"]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,\"hr\"],[14,0,\"u--m__tb__lg\"],[12],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"o--form__checkbox u--m__b\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"o--checkbox__label\"],[12],[1,\"\\n              \"],[8,[39,2],null,[[\"@checked\",\"@type\"],[[30,0,[\"notificationPostTerms\"]],\"checkbox\"]],null],[1,\"\\n              \"],[1,[28,[35,1],[\"tiktok.add_profile.notification_terms\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,6],null,[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"],[8,[39,6],[[24,0,\"u--float--right\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,7],[[30,0,[\"isAddProfileEnabled\"]]],null],[30,0,[\"addTiktokProfile\"]],[28,[37,1],[\"tiktok.add_profile.add_handle_btn\"],null],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showTiktokDetailsModal\"]],[[[1,\"  \"],[8,[39,9],null,[[\"@handleClose\"],[[28,[37,10],[[30,0],\"showTiktokDetailsModal\",false],null]]],null],[1,\"\\n\"]],[]],null]],[\"@handleClose\",\"modal\"],false,[\"shared/modal\",\"t\",\"input\",\"on\",\"toggle-action\",\"svg-jar\",\"shared/ui/button\",\"not\",\"if\",\"shared/social/tiktok-details\",\"set\"]]",
    "moduleName": "shared/components/shared/social/tiktok-modal.hbs",
    "isStrictMode": false
  });

  let TiktokModalComponent = (_dec = (0, _computed.notEmpty)('tiktokHandle'), _dec2 = (0, _computed.and)('hasTiktokHandle', 'notificationPostTerms'), (_class = class TiktokModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "notificationPostTerms", _descriptor, this);

      _initializerDefineProperty(this, "tiktokHandle", _descriptor2, this);

      _initializerDefineProperty(this, "hasTiktokHandle", _descriptor3, this);

      _initializerDefineProperty(this, "isAddProfileEnabled", _descriptor4, this);
    }

    addTiktokProfile(event) {
      event.preventDefault();
      this.args.addTiktokProfile(this.tiktokHandle);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "notificationPostTerms", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tiktokHandle", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hasTiktokHandle", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isAddProfileEnabled", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addTiktokProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addTiktokProfile"), _class.prototype)), _class));
  _exports.default = TiktokModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TiktokModalComponent);
});